import { __assign } from "tslib";
import * as React from 'react';
import Root from '@websky/core/src/MobileSegmentInfo/components/MobileSegmentFlat/MobileSegmentFlatTime/MobileSegmentFlatTime';
var MobileSegmentFlatTime = function (props) {
    return React.createElement(Root, __assign({}, props, { showAirports: true }));
};
export default MobileSegmentFlatTime;
